import { differenceInCalendarDays, differenceInCalendarMonths, differenceInHours } from "date-fns";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

const counters: Record<string, (range: DateRange) => number> = {
  day: (range) => differenceInCalendarDays(range.endDate, range.startDate) + 1,
  hour: (range) => differenceInHours(range.endDate, range.startDate) + 1,
  month: (range) => differenceInCalendarMonths(range.endDate, range.startDate) + 1,
  week: (range) => Math.ceil((differenceInCalendarDays(range.endDate, range.startDate) + 1) / 7),
};

export const getBucketCount = (range: DateRange, granularity: string): number =>
  Math.max(1, counters[granularity]?.(range) ?? 1);

export default getBucketCount;
